<template>
  <ModalConfirmationDialog
    v-bind="$attrs"
    v-on="$listeners"
    :name="name"
    :primaryActionLabel="'OK'"
    :secondaryActionLabel="'Cancel'"
    @before-close="beforeClose"
    @before-open="beforeOpen"
    @click-primary="$emit('complete-survey', survey)"
    @click-secondary="close"
  >
    <div :style="style.text">
      Once you submit,<br><span :style="style.surveyName">{{ surveyName }}</span> will no longer appear in Home Page.
    </div>
  </ModalConfirmationDialog>
</template>

<script>
  import ModalConfirmationDialog
    from '@modules/v2/modal/modal-confirmation-dialog'
  import { DIALOG_NAMES } from '@js/constants'
  import { FontStyle } from '@js/styles'

  export default {
    name: 'DialogCompleteSurveyPrimary',
    inheritAttrs: false,
    components: {
      ModalConfirmationDialog,
    },
    data: function () {
      return {
        name: DIALOG_NAMES.COMPLETE_SURVEY_PRIMARY,
        survey: {},
        style: {
          surveyName: {
            fontWeight: FontStyle.weight.xl,
          },
          text: {
            textAlign: 'center',
          },
        },
      };
    },
    computed: {
      surveyName: function () {
        return this.survey?.name;
      },
    },
    methods: {
      beforeClose: function (e) {
        this.clearCache();
      },
      beforeOpen: function (e) {
        this.clearCache();

        if (e.params?.survey) {
          this.survey = e.params.survey;
        } else {
          this.$store.commit(
            'notification/setWarning',
            'Failed to load survey',
          );
          this.close();
        }
      },
      clearCache: function () {
        this.survey = {};
      },
      close: function () {
        this.$modal.hide(this.name);
      },
    },
  };
</script>
